export default __webpack_public_path__ + "static/media/BookFusion.75537e9db2fc1e86fbd6449eb1772cb7.webp";